import BudgetChart from './BudgetChart';

export default BudgetChart;
